import Component from '../../lib/Component';

class VisualNovel extends Component {
  static override tag = 'visual-novel';

	override async render (): Promise<string> {
		return '';
	}
}

export default VisualNovel;
